import type { SVGProps } from 'react';

/**
 * Sprechblase mit Sparkle — symbolisiert KI-Prompt-Ausgangspunkt.
 */
export function EmptyPromptIllustration(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M28 36 H92 a8 8 0 0 1 8 8 v32 a8 8 0 0 1 -8 8 H62 l-14 12 v-12 H28 a8 8 0 0 1 -8 -8 v-32 a8 8 0 0 1 8 -8 z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        opacity="0.55"
      />
      <path
        d="M84 28 L86 36 L94 38 L86 40 L84 48 L82 40 L74 38 L82 36 Z"
        className="text-brand-500"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="currentColor"
        fillOpacity="0.18"
      />
      <line x1="34" y1="52" x2="78" y2="52" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <line x1="34" y1="60" x2="64" y2="60" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.35" />
    </svg>
  );
}
